<template>
  <div class="card dashcard" style="padding: 0px;" >
    <div class="card-header d-flex justify-content-between" :class="header">
      <span>{{ title }}</span>
      <span v-if="titlecenter">{{ titlecenter }}</span>
      <span>{{ titleright }}</span>
    </div>
    <div class="card-body">
      <slot v-if="!lista"></slot>
      <template v-if="!this.$store.state.loading">
        <template v-for="(valor, itx) in lista">
          <div :key="itx" v-if="!valor.optional || parseFloat(valor.valor) > 0" class="d-flex justify-content-between mb-2">
            <span>
              <div>
                <a href="#" class="card-link" @click.prevent="callback ? callback(valor.status) : listar (valor.status)" v-if="valor.status">
                  {{ valor.title }}
                </a>
                <span class="badge badge-primary" v-if="valor.guias" data-toggle="tooltip" data-placement="top" title="Número de Guias">
                  {{ valor.guias }}
                </span>
              </div>
              <div class="small text-muted" v-if="valor.criacao">
                Mais antiga: {{ $util.getFormatDate(valor.criacao) }} {{ getHumanDuration (valor.criacao) }}
              </div>
            </span>
            <h3 :class="valor.class">
              {{ valor.valor }}
            </h3>
          </div>
        </template>
      </template>
      <div v-else>
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import * as moment from 'moment';

export default {
  props: ["title", "item", "pendencia", "header", "link", "parms", "lista", "criacao", "titleright", "titlecenter", "callback"],

  methods: {
    listar(status) {
      this.$router.push({ name: "guias", params: { status: status } });
    },

    getHumanDuration (date) {  
      let end = moment().startOf('day');
      let base = date.substr (0,10);
      
      if ( base == this.$util.hoje() ) 
          return 'hoje';
      else
          return 'há ' + moment(end, 'YYYY-MM-DD').diff(base, 'days') + ' dia(s)';
          // moment.duration(moment(base, 'YYYY-MM-DD').diff(end))
            //moment.duration(moment(base, 'YYYY-MM-DD').diff(end));// .humanize(true);
    },
  },

  updated () { 
      $('[data-toggle="tooltip"]').tooltip();
  }
};
</script>